import React, { useEffect } from 'react';
import { Alert } from 'components/common';
import { useCredential, useUser } from 'components/hooks';
import { ROUTES } from 'consts';
import { formatProjectItems } from 'helpers';
import withRequest from 'hoc/withRequest';
import { useHistory, withRouter } from 'react-router-dom';
import { CredentialSchema } from 'schemas';
import CredentialOldFormDumb from './CredentialOldFormDumb';


const InventoryCreateOldSmart = () => {
  const { parameters } = useUser();
  const projects = formatProjectItems(parameters);
  const history = useHistory();
  const { cleanUpMessage, error, success, postCredential } = useCredential();

  const defaultValues = {
    name: '',
    description: '',
    project: projects[0].value,
    credentials: ''
  };

  const handleCloseAlert = () => cleanUpMessage();

  const findProjectBaseUrl = (project) => {
    const projectFound =  projects.find(p => Number(p.value) === Number(project));
    return projectFound.base_url;
  }

  const handleCreate = (data) => {
    const credential = new CredentialSchema();
    credential.setValues(data);
    credential.values.fromEdit = false;
    credential.values.selectProyectoURL = findProjectBaseUrl(data.project)
    postCredential({
      body: credential.getValues(),
    });
  };


  /*


  */

  useEffect(() => {
    if (!!success.post) history.push(ROUTES.CREDENTIAL_LIST);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [success.post]);


  return (
    <>
      { projects && <CredentialOldFormDumb defaultValues={defaultValues} handleOnSubmit={handleCreate} isEdit={false} />}
      <Alert severity="error" handleClose={handleCloseAlert} open={error.post} message="common.errors.general.title" />
    </>
  );
};

export default withRequest(withRouter(InventoryCreateOldSmart));
